module.exports = __webpack_public_path__ + "static/media/admins.09329de6.svg";